/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {TranslationsService as ɵa} from './lib/shared/utils/translations.service';